import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { colors } from 'theme/colors';
import { Box } from '@mui/material';

export const AuditLogDetails = styled(Grid)`
  margin: 20px 0;
  background-color: ${colors.gray50};
  border: 1px solid ${colors.gray300};
  border-radius: 4px;
`;

export const AuditLogEventName = styled(Box)`
  background-color: ${colors.primary900};
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 4px;

  & h5 {
    font-weight: 400;
    color: ${colors.white};
  }
`;

export const AuditLogDetailsWrapper = styled(Grid)`
  background-color: ${colors.gray100};
  padding: 20px 15px 20px 15px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid ${colors.gray200};
`;

export const StyledFilterChipWrapper = styled(Grid)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StyledDivider = styled.div`
  margin: 20px 0;
  height: 1px;
  width: 100%;
  background-color: ${colors.primary25};
`;
